import {Button, Col, Form, Modal, Row, Spinner} from 'react-bootstrap'
import {InputCurrency} from '../../../components/InputCurrency'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useMutation, useQuery} from '@apollo/client'
import {GET_ALL_POLICIES_TYPES} from '../../../gql/queries/policiesQueries'
import {IResPoliciesType} from '../../../types/policies'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {GET_STATES_EU} from '../../../gql/queries/statesEUQuery'
import {IResStates} from '../../../types/statesEU'
import Select, {SingleValue} from 'react-select'
import {ADD_COMMISSION} from '../../../gql/mutations/carriersMutations'
import {
  ICommissionRate,
  IResCreateCommission,
  IResCreateCommissionRate,
  IResUpdateCommissionRate,
  IResUpdateommission,
} from '../../../types/carriers'
import {parseId} from '../../../helpers'
import {getStateEUById} from '../../shared/utils'
import {
  ADD_COMMISSION_RATE,
  EDIT_COMMISSION_RATE,
} from '../../../gql/mutations/commissionsRateMutations'

interface IModalAddCommissionRateProps {
  keyboard: boolean
  backdrop: string
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  carrierId: string
  isEdit?: boolean
  commissionId?: ICommissionRate | undefined
}

export const ModalAddCommissionRate: React.FC<IModalAddCommissionRateProps> = ({
  keyboard,
  backdrop,
  isOpen,
  onClose,
  carrierId,
  isEdit = false,
  commissionId,
  refetch,
}) => {
  const [gqlCreate, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreateCommissionRate>(ADD_COMMISSION_RATE)

  const [gqlUpdate, {data: dataUpdate, loading: loadingUpdate, error: errorUpdate}] =
    useMutation<IResUpdateCommissionRate>(EDIT_COMMISSION_RATE)

  const {
    data: dataStates,
    loading: loadingStates,
    error: errorStates,
  } = useQuery<IResStates>(GET_STATES_EU, {
    fetchPolicy: 'no-cache',
  })

  // const [stateValue, setStateValue] = useState<SingleValue<{label: string; value: string}>>()

  const validationSchema = Yup.object({
    carrier: Yup.string().required('Carrier is required'),
    stateEU: Yup.string(), // opcional
    rateNew: Yup.number().required('Rate new is required'),
    rateRenew: Yup.number().required('Rate renew is required'),
  })

  const formik = useFormik({
    initialValues: {
      carrier: carrierId, // ID del InsuranceOperator
      stateEU: '' + commissionId?.stateEU.id, // ID del State (opcional)
      rateNew: commissionId?.rateNew || '', // Porcentaje como string para poder usar input tipo texto
      rateRenew: commissionId?.rateRenew || '',
    },
    validationSchema,
    onSubmit: (v) => {
      console.log('v', v)
      if (commissionId && commissionId.id) {
        gqlUpdate({
          variables: {
            id: parseId(commissionId.id),
            input: {
              carrier: carrierId,
              stateEU: '' + parseId(v.stateEU) || null,
              rateNew: '' + parseFloat(v.rateNew),
              rateRenew: '' + parseFloat(v.rateRenew),
            },
          },
        })
      } else {
        gqlCreate({
          variables: {
            input: {
              carrier: carrierId,
              stateEU: '' + parseId(v.stateEU) || null, // Si es opcional
              rateNew: '' + parseFloat(v.rateNew),
              rateRenew: '' + parseFloat(v.rateRenew),
            },
          },
        })
      }
    },
  })

  // useEffect(() => {
  //   if (errorPolicies) toast.error(`Error ${errorPolicies.message}`)
  // }, [errorPolicies])

  useEffect(() => {
    if (errorStates) toast.error(`Error ${errorStates.message}`)
  }, [errorStates])

  useEffect(() => {
    if (errorCreate) toast.error(`Error ${errorCreate.message}`)
  }, [errorCreate])

  useEffect(() => {
    if (!dataCreate) return

    if (
      dataCreate.commissionRateCreate.success &&
      dataCreate.commissionRateCreate.commissionRate?.id
    ) {
      toast.success('Commission rate updated successfully')
      onClose()
      refetch()
    } else if (
      dataCreate.commissionRateCreate.errors &&
      dataCreate.commissionRateCreate.errors.length > 0
    ) {
      toast.error(dataCreate.commissionRateCreate.errors[0]?.message || 'Created failed')
    }
  }, [dataCreate])

  useEffect(() => {
    if (!dataUpdate) return

    if (
      dataUpdate.commissionRateUpdate.success &&
      dataUpdate.commissionRateUpdate.commissionRate?.id
    ) {
      toast.success('Commission rate updated successfully')
      onClose()
      refetch()
    } else if (
      dataUpdate.commissionRateUpdate.errors &&
      dataUpdate.commissionRateUpdate.errors.length > 0
    ) {
      toast.error(dataUpdate.commissionRateUpdate.errors[0]?.message || 'Update failed')
    }
  }, [dataUpdate])

  return (
    <Modal
      className='modal-add-commission'
      backdrop='static'
      keyboard={false}
      show={isOpen}
      onHide={onClose}
    >
      {/* <Modal show={isOpen} onHide={onClose}> */}
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Edit' : 'Add'} commission rate</Modal.Title>
      </Modal.Header>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <Row>
            <Col sm={12} md={12}>
              <Form.Group>
                <Form.Label htmlFor='state'>State</Form.Label>
                {dataStates?.allStates && (
                  <Form.Select
                    id='stateEU'
                    name='stateEU'
                    value={
                      getStateEUById(dataStates?.allStates, '' + commissionId?.stateEU?.id)?.id
                    }
                    onChange={(e) => {
                      formik.setFieldValue('stateEU', e.target.value || '')
                    }}
                  >
                    <option value=''>All</option>
                    {dataStates?.allStates?.edges.map(({node}) => (
                      <option key={node.id} value={node.id}>
                        {node.name} ({node.code})
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className='mb-3'>
            <Form.Label>Rate new</Form.Label>
            <InputCurrency
              name='rateNew'
              value={formik.values.rateNew}
              onValueChange={(val) => formik.setFieldValue('rateNew', val || '0')}
            />
            {formik.touched.rateNew && typeof formik.errors.rateNew === 'string' && (
              <small className='text-danger'>{formik.errors.rateNew}</small>
            )}
          </Form.Group>
          <Form.Group className='mb-3'>
            <Form.Label>Rate renew</Form.Label>
            <InputCurrency
              name='rateRenew'
              value={formik.values.rateRenew}
              onValueChange={(val) => formik.setFieldValue('rateRenew', val || '0')}
            />
            {formik.touched.rateRenew && typeof formik.errors.rateRenew === 'string' && (
              <small className='text-danger'>{formik.errors.rateRenew}</small>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' size='sm' onClick={onClose} type='button'>
            Close
          </Button>
          <Button variant='primary' size='sm' type='submit' disabled={loadingCreate}>
            {loadingCreate && <Spinner animation='border' size='sm' className='me-2' />}
            Save Changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
